// DS1.7.13
import React from 'react';
const DAProtectIndicator = ({ variant , className  })=>{
    switch(variant){
        case 'temporary':
            return /*#__PURE__*/ React.createElement("svg", {
                className: className,
                width: "24",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 25"
            }, /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 6.09 12 3l7 3.09v4.637a9.584 9.584 0 0 1-.629 3.389 5.503 5.503 0 0 0-4.364 5.098A8.428 8.428 0 0 1 12 20c-4.044-1.005-7-5.023-7-9.273V6.091Zm5.938 9.745-.175.165H9v-1.636l1.777-3.152-.145-.165H9V8.8h2.968l.262-.164.832-1.471.176-.165H15v1.636l-1.777 3.153.145.164H15V14.2h-2.968l-.262.164-.832 1.471Z",
                fill: "currentColor"
            }), /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17 18c.074 1.286.804 2.444 1.786 2.793.208.128.357.386.357.698 0 .312-.149.57-.357.698-.982.35-1.712 1.525-1.786 2.811h5c-.074-1.305-.804-2.462-1.786-2.811-.208-.129-.357-.386-.357-.698 0-.313.149-.57.357-.698.982-.35 1.712-1.507 1.786-2.793h-5Z",
                fill: "#00E59B"
            }));
        case 'inactive':
            return /*#__PURE__*/ React.createElement("svg", {
                className: className,
                width: "24",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 26"
            }, /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 3 5 6.09v4.637c0 4.25 2.956 8.268 7 9.273a6 6 0 1 0 6.409-5.986A9.571 9.571 0 0 0 19 10.727V6.091L12 3Zm-1.237 13 .175-.165.832-1.471.262-.164H15v-2.247h-1.632l-.145-.164L15 8.636V7h-1.762l-.176.165-.832 1.471-.262.164H9v2.247h1.632l.145.165L9 14.364V16h1.763ZM18 25a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm-1-5v-3h2v3h-2Zm0 3v-2h2v2h-2Z",
                fill: "currentColor"
            }));
        case 'active':
            return /*#__PURE__*/ React.createElement("svg", {
                className: className,
                width: "24",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24"
            }, /*#__PURE__*/ React.createElement("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5 6.09 12 3l7 3.09v4.637a9.584 9.584 0 0 1-.629 3.389 5.503 5.503 0 0 0-4.364 5.098A8.428 8.428 0 0 1 12 20c-4.044-1.005-7-5.023-7-9.273V6.091Zm5.938 9.745-.175.165H9v-1.636l1.777-3.152-.145-.165H9V8.8h2.968l.262-.164.832-1.471.176-.165H15v1.636l-1.777 3.153.145.164H15V14.2h-2.968l-.262.164-.832 1.471Z",
                fill: "currentColor"
            }), /*#__PURE__*/ React.createElement("path", {
                d: "m16.5 20 1.225-1.286 2.017 1.715L22.775 17 24 18.286 19.742 23 16.5 20Z",
                fill: "#00E59B"
            }));
        default:
            return null;
    }
};
DAProtectIndicator.displayName = 'DAProtectIndicator';
export default DAProtectIndicator;
